module.exports = __webpack_public_path__ + "static/media/Banner-SabonMed.6d043fc2.jpg";